
/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import { useState, useEffect } from "react";
import { Grid } from "@mui/material";
import PropTypes from "prop-types";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import TradeDiary from 'components/TradeDiary';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import {} from '../../firebaseConfig';

const DiaryPage = ({ userID, userData }) => {
  useEffect(() => {
    // Get the Firebase Auth instance
    const auth = getAuth();

    // Listen for auth state changes
    onAuthStateChanged(auth, (user) => {
      if (user) {
        // User is logged in
        console.log("User is signed in with UID:", user.uid);
      } else {
        // User is not logged in
        console.log("User is signed out");
      }
    });
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mt={10} mb={3}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            {/* Diary entry component */}
            <TradeDiary userID={userID} />
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

DiaryPage.propTypes = {
  userID: PropTypes.string.isRequired,
  userData: PropTypes.object,
};

export default DiaryPage;
